import { DetailManyToOneTable } from '@/@diffrag/form/DetailManyToOneTable'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { IAdminPointRuleROO1 } from 'api'

export default function Point() {
  const { data } = useApi({
    id: 'pointRuleList',
    fn: api().adminPointRule.adminPointRuleList,
  })

  const onSave = async (form: { data: IAdminPointRuleROO1[] }) => {
    const deletedItems = data?.rows.filter(
      (item) => !form.data.some((rowItem) => rowItem.id === item.id),
    )

    if (deletedItems) {
      for (const item of deletedItems) {
        await api().adminPointRule.adminPointRuleDelete(item.id)
      }
    }

    for (const item of form.data) {
      await api().adminPointRule.adminPointRuleUpdate(item.id, {
        name: item.name,
        amount: item.amount,
      })
    }
  }

  return (
    <ContentDetailView
      data={{
        data: data?.rows,
      }}
      title="포인트 관리"
      onSave={onSave}
    >
      <DetailManyToOneTable
        name="data"
        title="포인트 관리"
        maxLength={0}
        hideDeleteButton
        getFields={() => [
          {
            label: '포인트명',
            key: 'name',
            type: FormFieldType.STRING,
          },
          {
            label: '적립 포인트',
            key: 'amount',
            type: FormFieldType.NUMBER,
          },
          // {
          //   label: '적립 사유',
          //   key: 'referenceType',
          //   valueMap: {
          //     SIGNUP: '회원가입',
          //     WRITE_PROFILE: '프로필 작성',
          //     ORDER: '주문',
          //     EVENT: '이벤트',
          //     REFERRAL: '추천',
          //     REVIEW: '리뷰 작성',
          //     COMMENT: '댓글 작성',
          //     COMMUNITY: '커뮤니티 작성',
          //     DAILY: '일일 출석',
          //     EXPIRE: '포인트 만료',
          //   },
          // },
        ]}
      />
    </ContentDetailView>
  )
}
